<template>
  <div>
    <div style="margin-bottom: 20px;">
      <img src="@/assets/images/dropsmart-logo.png" alt="Logo" class="logoCheckout" />
    </div>

      <b-row v-if="expirationDate">
      <b-col sm="12" class="time-counter-row">
        <countdown :end-time="expirationDate">
          <template v-slot:process="expirationCountdown">
            <div class="time-counter">
              <div id="time-counter-container-2">
                <div>
                  <div class="value">{{ expirationCountdown.timeObj.d }}<span>|</span></div>
                  <div class="label">days</div>
                </div>
                <div>
                  <div class="value">{{ expirationCountdown.timeObj.h }}<span>:</span></div>
                  <div class="label">hours</div>
                </div>
                <div>
                  <div class="value">{{ expirationCountdown.timeObj.m }}<span>:</span></div>
                  <div class="label">minutes</div>
                </div>
                <div>
                  <div class="value">{{ expirationCountdown.timeObj.s }}</div>
                  <div class="label">seconds</div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:finish>
            <div style="margin: 0 0 2rem 0;">
            <a id="expired-offer-link" href="https://center.dropsmarteo.com/checkout?period=yearly">I'M SORRY. THIS OFFER IS CLOSED! Click here for Dropsmart Premium.</a>
            </div>
          </template>
        </countdown>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ['expirationDate'],
}
</script>

<style scoped lang="scss" >

#expired-offer-link {
  font-size: 1.5rem;
  color: red;
  font-weight: 900;
}

#expired-offer-link:hover {
  color: red;
  text-decoration: underline;
}
#expired-offer-link:visited {
  color: red;
  text-decoration: none;
}

#time-counter-container-2 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 40px 0;
}

#time-counter-container-2 div {
  width: 3em;
  font-size: 3rem;
  font-weight: 400;
}
#time-counter-container-2 span {
  float: right;
}
#time-counter-container-2 .value {
  height: 60px;
}
#time-counter-container-2 .label {
  font-weight: normal;
  font-size: 0.9rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #555;
}
</style>
